// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stat-card {
  background: white;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  transition: transform 0.3s ease, opacity 0.3s ease;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  
}

.stat-card.animate-in {
  transform: translateY(0);
  opacity: 1;
}

.stat-card:not(.animate-in) {
  transform: translateY(20px);
  opacity: 0;
}

/* Color classes */
.text-primary {
  color: #3b82f6;
}

.text-warning {
  color: #f59e0b;
}

.text-success {
  color: #10b981;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .stats-grid {
      grid-template-columns: 1fr;
  }
  
  .stat-card {
      padding: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/Styles/StatCard.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,wCAAwC;EACxC,kBAAkB;EAClB,kDAAkD;EAClD,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;;AAEzB;;AAEA;EACE,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,UAAU;AACZ;;AAEA,kBAAkB;AAClB;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE;MACI,0BAA0B;EAC9B;;EAEA;MACI,aAAa;EACjB;AACF","sourcesContent":[".stat-card {\n  background: white;\n  border-radius: 8px;\n  padding: 1.5rem;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  text-align: center;\n  transition: transform 0.3s ease, opacity 0.3s ease;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  \n}\n\n.stat-card.animate-in {\n  transform: translateY(0);\n  opacity: 1;\n}\n\n.stat-card:not(.animate-in) {\n  transform: translateY(20px);\n  opacity: 0;\n}\n\n/* Color classes */\n.text-primary {\n  color: #3b82f6;\n}\n\n.text-warning {\n  color: #f59e0b;\n}\n\n.text-success {\n  color: #10b981;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .stats-grid {\n      grid-template-columns: 1fr;\n  }\n  \n  .stat-card {\n      padding: 1rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
